import React from "react";
import { ManageBlocksComponent } from "../../../components/manage-blocks-components";

export const ManageBlocksPage: React.FC = () => {
    return <ManageBlocksComponent />;
};
